import React, {useState} from 'react';
import StatusAccountUser from "../../../../utils/StatusAccountUser";
import FCSelect from "../../../FCObjets/Form/FCSelect";

export interface InterfaceAccountAdmin {
    role: string;
    stateAccount: number;
}

export type AccountAdminProps = {
    handlerChange: (dataUser: InterfaceAccountAdmin) => void;
    data: InterfaceAccountAdmin;
}

const FormAccountAdmin: React.FC<AccountAdminProps> = ({handlerChange, data}) => {

    const [dataAdmin, setDataAdmin] = useState<InterfaceAccountAdmin>(data);

    const eventChange = (key: keyof InterfaceAccountAdmin, value: string | number) => {
        const v: InterfaceAccountAdmin = {...dataAdmin, [key]: value};
        setDataAdmin(v);
        handlerChange(v);
    };

    return (
        <>
            <div className="configField">
                <label>Rôle</label>
                <FCSelect
                    options={[
                        {value: "ADMIN", label: "Admin"},
                        {value: "GUEST", label: "Guest"},
                    ]}
                    value={dataAdmin.role}
                    onChange={(v) => eventChange("role", String(v))}
                />
            </div>

            <div className="configField">
                <label>État du compte</label>
                <FCSelect
                    options={StatusAccountUser.ListStatus.map((s) => ({
                        value: s,
                        label: StatusAccountUser.toString(s)
                    }))}
                    value={dataAdmin.stateAccount}
                    onChange={(v) => eventChange("stateAccount", Number(v))}
                />
            </div>
        </>
    );
};

export default FormAccountAdmin;
